import { useMatch } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { incidentRecordQuery } from "@/app/Incidents/GraphQL/incidentRecordQuery";

export function useIncidentRecord() {
  const match = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/pro-drivers/incidents/$incidentId",
  });

  const { data } = useSuspenseGqlQuery(incidentRecordQuery, {
    id: match.params.incidentId,
  });

  return data.incident;
}
